import { createReducer, on } from '@ngrx/store';
import {
  addMultiselectValue, resetFilterByKey, resetFiltersByEntity,
  resetRookieDayDistrictScopedFilters, resetRookieDistrictScopedFilters,
  resetJobFilter, setFilteredJobsNumber, setFilteredProfessionsNumber, setFilteredProvidersNumber,
  setFilteredRookieNumber, setJobFilter, setUpdateArchiveView,
  toggleJobFilterValue, toggleSelectedProviderType,
  toggleSelectedRequirement, toggleSelectedSchoolSubject
} from "../actions/filter.actions";

export const filterFeatureKey = 'filter';

export interface FilterState {
  educationPaths: number[];
  isScholasticProfession: boolean; // TODO do we need this?
  searchTerm: string;
  searchTermProfession: string;
  searchTermProviderLocation: string;
  searchTermJobLocation: string;
  archiveSortBy: string,
  providersArchiveSortBy: string,
  jobsArchiveSortBy: string,
  professionsPageIdx: number;
  providersPageIdx: number;
  jobsPageIdx: number;
  selectedRequirements: number[];
  selectedSchoolSubjectIds: number[];
  selectedProviderTypes: number[];
  selectedInterestFields: number[];
  selectedProviderInterestFields: number[];
  selectedJobInterestFields: number[];
  filteredProfessionsNumber: number;
  filteredProvidersNumber: number;
  filteredJobsNumber: number;
  selectedProviderOffers: number[];
  selectedOfferTypes: number[];
  professionsWithStories: boolean;
  searchTermCompany: string;
  searchTermJob: string;
  updateArchiveView: boolean;
  providersWithQuiz: boolean;
  providersComplete: boolean;
  isGreenProfession: boolean;
  jobsApprenticeshipMaturaOnly: boolean;
  jobsPartialQualificationOnly: boolean;
  providersDistance: number;
  jobsDistance: number;
  activeProviderDistrictIds: number[];
  activeJobDistrictIds: number[];
  relatedProviderProfessionBicId: number;
  relatedJobProfessionBicId: number; // relatedProfessionBicId
  userLocationProvider: { lat: number, lng: number },
  userLocationJob: { lat: number, lng: number },
  searchTermRookie: string;
  selectedRookieInterestFields: number[];
  selectedRookieSchool: number;
  selectedRookieDaySchool: number;
  selectedRookieProvider: number;
  selectedRookieProfession: number;
  selectedRookieTimeslots: any[];
  filteredRookieNumber: number;
  rookieAvailableSlotsOnly: boolean;
}

export const initialState: FilterState = {
  educationPaths: new Array(0),
  isScholasticProfession: false,
  searchTerm: "",
  searchTermProfession: "",
  searchTermProviderLocation: "",
  searchTermJobLocation: "",
  archiveSortBy: "name-asc",
  providersArchiveSortBy: "name-asc",
  jobsArchiveSortBy: "name-asc",
  professionsPageIdx: 1,
  providersPageIdx: 1,
  jobsPageIdx: 1,
  selectedRequirements: new Array(0),
  selectedSchoolSubjectIds: new Array(0),
  selectedProviderTypes: new Array(0),
  selectedProviderOffers: new Array(0),
  selectedOfferTypes: new Array(0),
  professionsWithStories: false,
  filteredProfessionsNumber: 0,
  filteredProvidersNumber: 0,
  filteredJobsNumber: 0,
  searchTermCompany: "",
  searchTermJob: "",
  updateArchiveView: true,
  selectedInterestFields: [],
  selectedProviderInterestFields: [],
  selectedJobInterestFields: [],
  providersComplete: false,
  providersWithQuiz: false,
  isGreenProfession: false,
  jobsApprenticeshipMaturaOnly: false,
  jobsPartialQualificationOnly: false,
  providersDistance: 0,
  jobsDistance: 0,
  activeProviderDistrictIds: [],
  activeJobDistrictIds: [],
  relatedProviderProfessionBicId: -1,
  relatedJobProfessionBicId: -1,
  userLocationProvider: { lat: 0, lng: 0 },
  userLocationJob: { lat: 0, lng: 0 },
  searchTermRookie: "",
  selectedRookieInterestFields: [],
  selectedRookieSchool: -1,
  selectedRookieDaySchool: -1,
  selectedRookieProvider: -1,
  selectedRookieProfession: -1,
  selectedRookieTimeslots: [],
  filteredRookieNumber: 0,
  rookieAvailableSlotsOnly: false
};

export const reducer = createReducer(
  initialState,
  on(addMultiselectValue, (state, action) => {
    return {
      ...state,
      [action.key]: action.value
    };
  }),
  on(setJobFilter, (state, action) => {
    if(action.key.length === 0) return state;

    return {
      ...state,
      [action.key]: action.value
    };
  }),
  on(toggleSelectedRequirement, (state, action) => {

    // @ts-ignore
    let currentValues = [...state.selectedRequirements];
    if(currentValues.indexOf(action.requirementId) > -1) {
      currentValues = currentValues.filter((el: number) => el !== action.requirementId);
    } else {
      currentValues.push(action.requirementId);
    }

    return {
      ...state,
      selectedRequirements: currentValues
    };

  }),
  on(toggleSelectedSchoolSubject, (state, action) => {

    // @ts-ignore
    let currentValues = [...state.selectedSchoolSubjectIds];
    if(currentValues.indexOf(action.schoolSubjectId) > -1) {
      currentValues = currentValues.filter((el: number) => el !== action.schoolSubjectId);
    } else {
      currentValues.push(action.schoolSubjectId);
    }

    return {
      ...state,
      selectedSchoolSubjectIds: currentValues
    };

  }),
  on(toggleSelectedProviderType, (state, action) => {

    // @ts-ignore
    let currentValues = [...state.selectedProviderTypes];
    if(currentValues.indexOf(action.providerType) > -1) {
      currentValues = currentValues.filter((el: number) => el !== action.providerType);
    } else {
      currentValues.push(action.providerType);
    }

    return {
      ...state,
      selectedProviderTypes: currentValues
    };

  }),
  on(toggleJobFilterValue, (state, action) => {

    if(action.key.length === 0) return state;

    // @ts-ignore
    let currentValues = [...state[action.key]];
    if(currentValues.indexOf(action.value) > -1) {
      currentValues = currentValues.filter((el: any) => el !== action.value);
    } else {
      currentValues.push(action.value);
    }
    // console.log(state);

    return {
      ...state,
      [action.key]: currentValues
    };

  }),

  on(setFilteredProfessionsNumber, (state, action) => {
    return {
      ...state,
      filteredProfessionsNumber: action.value
    };
  }),

  on(setFilteredProvidersNumber, (state, action) => {
    return {
      ...state,
      filteredProvidersNumber: action.value
    };
  }),

  on(setFilteredJobsNumber, (state, action) => {
    return {
      ...state,
      filteredJobsNumber: action.value
    };
  }),

  on(setFilteredRookieNumber, (state, action) => {
    return {
      ...state,
      filteredRookieNumber: action.value
    };
  }),

  on(resetFilterByKey, (state, action) => {
    return {
      ...state,
      [action.key]: new Array(0)
    };
  }),

  on(resetFiltersByEntity, (state, action) => {
    if(action.key === "allProfession") {
      return {
        ...state,
        searchTermProfession: "",
        professionsPageIdx: 1,
        educationPaths: [],
        selectedRequirements: [],
        selectedSchoolSubjectIds: [],
        selectedInterestFields: [],
        professionsWithStories: false,
        isGreenProfession: false
      };
    } else if(action.key === "allProvider") {
      return {
        ...state,
        searchTermCompany: "",
        selectedProviderTypes: [],
        selectedProviderInterestFields: [],
        selectedProviderOffers: [],
        providersWithQuiz: false,
        providersComplete: false,
        providersDistance: 0,
        activeProviderDistrictIds: [],
        searchTermProviderLocation: "",
        relatedProviderProfessionBicId: -1

      };
    } else if(action.key === "allJob") {
      return {
        ...state,
        searchTermJob: "",
        selectedOfferTypes: [],
        selectedJobInterestFields: [],
        jobsApprenticeshipMaturaOnly: false,
        jobsPartialQualificationOnly: false,
        jobsDistance: 0,
        activeJobDistrictIds: [],
        searchTermJobLocation: "",
        relatedJobProfessionBicId: -1
      };
    } else if(action.key === "allRookie") {
      return { // no school reset, must always be selected
        ...state,
        searchTermRookie: "",
        selectedRookieInterestFields: [],
        rookieAvailableSlotsOnly: false,
        selectedRookieProvider: -1,
        selectedRookieProfession: -1,
        selectedRookieTimeslots: [],
      };
    } else {
      return {
        ...state
      }
    }

  }),

  on(setUpdateArchiveView, (state, action) => {
    return {
      ...state,
      updateArchiveView: action.updateActive
    };
  }),

  on(resetJobFilter, (state, action) => {
    return {
      educationPaths: new Array(0),
      isScholasticProfession: false,
      searchTerm: "",
      searchTermProfession: "",
      searchTermProviderLocation: "",
      searchTermJobLocation: "",
      archiveSortBy: "name-asc",
      providersArchiveSortBy: "name-asc",
      jobsArchiveSortBy: "name-asc",
      professionsPageIdx: 1,
      providersPageIdx: 1,
      jobsPageIdx: 1,
      selectedRequirements: new Array(0),
      selectedSchoolSubjectIds: new Array(0),
      selectedProviderTypes: new Array(0),
      selectedProviderOffers: new Array(0),
      selectedOfferTypes: new Array(0),
      professionsWithStories: false,
      filteredProfessionsNumber: 0,
      filteredProvidersNumber: 0,
      filteredJobsNumber: 0,
      searchTermCompany: "",
      searchTermJob: "",
      updateArchiveView: true,
      selectedInterestFields: [],
      selectedProviderInterestFields: [],
      selectedJobInterestFields: [],
      providersComplete: false,
      providersWithQuiz: false,
      isGreenProfession: false,
      jobsApprenticeshipMaturaOnly: false,
      jobsPartialQualificationOnly: false,
      providersDistance: 0,
      jobsDistance: 0,
      activeProviderDistrictIds: [],
      activeJobDistrictIds: [],
      relatedProviderProfessionBicId: -1,
      relatedJobProfessionBicId: -1,
      userLocationProvider: { lat: 0, lng: 0 },
      userLocationJob: { lat: 0, lng: 0 },
      searchTermRookie: "",
      selectedRookieInterestFields: [],
      selectedRookieSchool: -1,
      selectedRookieDaySchool: -1,
      selectedRookieProvider: -1,
      selectedRookieProfession: -1,
      selectedRookieTimeslots: [],
      filteredRookieNumber: 0,
      rookieAvailableSlotsOnly: false
    };
  }),

  // Rookie district switch: only the values whose ids belong to a single district are dropped.
  // selectedRookieInterestFields and rookieAvailableSlotsOnly are district-agnostic and stay.
  on(resetRookieDistrictScopedFilters, (state) => {
    return {
      ...state,
      searchTermRookie: "",
      selectedRookieSchool: -1,
      selectedRookieTimeslots: [],
      selectedRookieProvider: -1,
      selectedRookieProfession: -1,
    };
  }),

  // RookieDay district switch. The school is the only district-scoped filter this area has —
  // the Lehrberuf filter lives in the component, and the job selection in JobSelectorService.
  on(resetRookieDayDistrictScopedFilters, (state) => {
    return {
      ...state,
      selectedRookieDaySchool: -1,
    };
  }),
);
